import { SET_NY_REBATE } from './constants';


export const setNYRebate = nyRebate => ({
    type: SET_NY_REBATE,
    nyRebate,
});



// WEBPACK FOOTER //
// ./src/containers/common/nyserda/actions.js